// React imports
import React, { useState, useEffect } from 'react';

// Form sections
import PersonalSection from './components/form-sections/PersonalSection';
import ProfessionalSection from './components/form-sections/ProfessionalSection';
import AgreementsSection from './components/form-sections/AgreementsSection';
import Thanks from './components/form-sections/Thanks';

// Assets and styles
import submittingImage from './submit_gif.png'; 
import mobile from './background_for_mobile.png';
import mobileIcon from './image_for_mobile.png';
import './style.css';

// Main App component
const App = () => {

   // Current section of form
  const [currentSection, setCurrentSection] = useState('personal');

   // Collected form data across sections
  const [formData, setFormData] = useState({});

   // Error message state
  const [error, setError] = useState('');

   // Detect if user is on mobile/tablet
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

   // State to show submission animation
  const [isSubmitting, setIsSubmitting] = useState(false);
  
   // On first load, restore saved section and formData from localStorage
  useEffect(() => {
    document.body.style.zoom = "100%"; // Prevent browser zoom
    const savedSection = localStorage.getItem('currentSection');
    const savedFormData = localStorage.getItem('formData');

    if (savedSection) setCurrentSection(savedSection);
    if (savedFormData) setFormData(JSON.parse(savedFormData));

    // Check for mobile/tablet screen size
    const checkDevice = () => {
      const width = window.innerWidth;
      if (width <= 1024) {                   // Treat devices <= 1024px as mobile/tablet
        setIsMobileOrTablet(true);
      } else {
        setIsMobileOrTablet(false);
      }
    };

    // Run checkDevice initially and also add resize event listener
    checkDevice(); 
    window.addEventListener('resize', checkDevice);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkDevice);
    };

  }, []);

  const handleNext = (updatedFormData) => {
    setFormData((prevData) => ({ ...prevData, ...updatedFormData }));
    setError(''); // Clear any previous errors

     // Determine the next section
    let nextSection = currentSection;
    if (currentSection === 'personal') nextSection = 'professional';
    else if (currentSection === 'professional') nextSection = 'agreements';
    else if (currentSection === 'agreements') nextSection = 'thankYou';

    setCurrentSection(nextSection);
    localStorage.setItem('currentSection', nextSection); // Save to localStorage
  };
     
     // Navigate to previous section 
  const handlePrevious = () => {
    let prevSection = currentSection;
    if (currentSection === 'professional') prevSection = 'personal';
    else if (currentSection === 'agreements') prevSection = 'professional';
    else if (currentSection === 'thankYou') prevSection = 'agreements';

    setCurrentSection(prevSection);
    localStorage.setItem('currentSection', prevSection); // Save to localStorage
  };

     // Save form data without proceeding to next section

  const handleSaveDraft = (updatedFormData) => {
    const newFormData = { ...formData, ...updatedFormData };
    setFormData(newFormData);
    localStorage.setItem('formData', JSON.stringify(newFormData)); // Save form data to localStorage
  };

   // Handle final form submission
  const handleSubmit = async (updatedFormData) => {
    const newFormData = { ...formData, ...updatedFormData };
     setFormData(newFormData);
      setIsSubmitting(true); // Show "submitting" animation
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/submit-form`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newFormData),
    });

    if (response.ok) {
        // Delay before thank you screen 
      setTimeout(() => {
        setIsSubmitting(false);
        setCurrentSection('thankYou');
        localStorage.setItem('currentSection', 'thankYou');
      }, 1500); // Optional delay
    } else {
      setError('Failed to submit form. Please try again.');
      setIsSubmitting(false);
    }
  } catch (error) {
    console.error('Error submitting form:', error);
    setError('Error submitting form. Please try again.');
    setIsSubmitting(false);
  }
};
    // Render specific section based on current step
  const renderSection = () => {
    switch (currentSection) {
      case 'personal':
        return (
          <PersonalSection
            formData={formData}
            onNext={handleNext}
            onSaveDraft={handleSaveDraft}
          />
        );
      case 'professional':
        return (
          <ProfessionalSection
            formData={formData}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onSaveDraft={handleSaveDraft}
          />
        );
      case 'agreements':
        return (
          <AgreementsSection
            formData={formData}
            onPrevious={handlePrevious}
            onSubmit={handleSubmit}
            onSaveDraft={handleSaveDraft}
            error={error}
          />
        );
      case 'thankYou':
        return <Thanks />;
      default:
        return (
          <PersonalSection
            formData={formData}
            onNext={handleNext}
            onSaveDraft={handleSaveDraft}
          />
        );
    }
  };
  

   return (
    <div className="form-wrapper">
      {isMobileOrTablet ? (
  <div className="mobile-warning-screen">
    <img src={mobile} alt="Background" className="mobile-background" />
    <div className="mobile-content">
      <img src={mobileIcon} alt="Illustration Icon" className="mobile-icon" />
      <p className="mobile-message">
        Our web-form is built for desktops only, but don’t worry—we’ve got the perfect solution! 🚀<br />
        Download the IPV App through Play Store or App Store. See you there! 📲<br /><br />
        For any queries, reach out to your Relationship Manager (RM).
      </p>
    </div>
  </div>
) : (
  renderSection()
)}
       {isSubmitting && (
         <div className="submit-toast-fullscreen">
          <div className="submit-toast-content">
           <img src={submittingImage} alt="Submitting..." className="submit-toast-image" />
            <div className="submit-toast-message">Submitting your information... Please wait.</div>
          </div>
         </div>
          )}
    </div>
    
  );
};

export default App;
